import React from 'react';
import { BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import DocDataExtractionForm from './DocDataExtractionForm';
import DocSubmittedAckForm from './DocSubmittedAckForm';

const FormView = (props) => {
    const { match,location } = props;
    
    switch (match.params.name){
        case "docDataExtractionForm":
            return <DocDataExtractionForm location={location} />;
        case "docSubmittedAckForm":
            return <DocSubmittedAckForm />
        default:
            return null;        
    }
}

const ProjectGorgon = (props) => {
    const { match } = props;
    return (
        <Router>
          <div>
             <Switch>
               <Route path={`${match.path}/:name`} component={FormView} />
               <Route path={`${match.path}/:name?jwt=:jwt&docUrl=:docUrl&taskAcceptedInfoId=:taskAcceptedInfoId`} component={FormView} />
               <Route render={()=>(
                   <h3>Project Gorgon</h3>
               )}/>
             </Switch> 
          </div>  
        </Router>
    )
}

export default ProjectGorgon;


// WEBPACK FOOTER //
// ./src/views/ProjectGorgon/ProjectGorgon.js